// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__8OBIb","footer":"ModalUpdate_footer__1tXE3"};